import { Component, OnInit } from '@angular/core';
import { AgentService } from '../../../@core/services/local/agent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY } from 'rxjs';
import { NbDialogService } from '@nebular/theme';
import { AgentOperationsComponent } from '../../../pages/application-form/agent-operations/agent-operations.component';
import { ModalService } from '../../../@core/services/local/modal.service';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  currentYear: number;
  companyName: string;
  email: string = ""

  agentCode: string;

  constructor(private agentService: AgentService, private activatedRoute: ActivatedRoute,
    private modalService: ModalService
  ) {
    let today = new Date();
    this.currentYear = today.getFullYear();
    this.companyName = "Sovos";
  }

  goToEmailOperations(isAgent:boolean) {
    this.modalService.openAgentOperationsModal.emit({isAgent : isAgent});
  }
  ngOnInit() {
    this.agentCode = this.activatedRoute.snapshot.queryParams['Agent'];
    this.agentService.getAgent().subscribe(data => {
      if (data != null) {
        if (this.agentCode) {
          this.email = data.EMAIL

        } else {
          this.email = "";
        }
      } else {
        this.email = "";
      }
    })
  }
}
